import {call, put, select, takeLatest} from "redux-saga/effects";
import {toast} from "react-toastify";
import * as actions from "../action.constants";
import {cloneProfileAsync} from "../AsyncActions/cloneProfile.async";
import {cloneStarted} from "../Actions/cloneProfile.actions";
import {getSelectedController} from "../Selectors/controllers.selectors";

function* cloneProfile(action) {
  const {sourceMac = ""} = action;

  try {
    const selectedController = yield select(getSelectedController);
    const targetMac = selectedController?.mac;

    const response = yield call(cloneProfileAsync, sourceMac, targetMac);
    const taskId = response?.data?.data?.task_id;

    if (!taskId) {
      toast.error("Failed to start cloning. Please try again.");
      return;
    }

    yield put(cloneStarted(taskId, targetMac));
  } catch (e) {
    // A response error (validation, "already in progress", etc.) is
    // already toasted with the server's actual message by the axiosV2
    // response interceptor. Toasting again here with e.message would show
    // a second, unhelpful generic message like "Request failed with
    // status code 400" instead. Only fall back here for a genuine
    // network-level failure, where there's no response to have shown.
    if (!e?.response) {
      toast.error(e?.message || "Cloning failed. Please try again.");
    }
  }
}

export function* cloneProfileSaga() {
  yield takeLatest(actions.CLONE_PROFILE, cloneProfile);
}
